import React from "react"
import PropTypes from "prop-types"
import ReactApexChart from "react-apexcharts"
import getChartColorsArray from "../../components/Common/ChartsDynamicColor"

const StackedColumnChart = ({ dataColors, periodData }) => {

  const stackedColumnChartColors = getChartColorsArray(dataColors);

  const options = {
    chart: {
      stacked: false,
      toolbar: { show: true },
      zoom: { enabled: true }
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "15%"
      }
    },
    dataLabels: {
      enabled: false
    },
    xaxis: {
      categories: periodData?.categories || []
    },
    yaxis: {
      labels: {
        formatter: function (value) {
          return (value / 100000).toFixed(1) + "L";
        }
      }
    },
    colors: stackedColumnChartColors,
    legend: {
      position: "bottom"
    },
    fill: {
      opacity: 1
    }
  };

  return (
    <ReactApexChart
      options={options}
      series={periodData?.series || []}
      type="bar"
      height={359}
      className="apex-charts"
    />
  );
};

StackedColumnChart.propTypes = {
  periodData: PropTypes.object
};

export default StackedColumnChart;